import { TabPanel } from "@material-ui/lab";
import SettingsPage from "pages/Settings";
import React from "react";
import EventSettingPage from "../EventSettingPage";
import FinancialSettingPage from "../FinancialSettingPage/FinancialSettingPage";
import MembersSettingPage from "../MembersSettingPage/MembersSettingPage";
import TemplatesSetting from "../templates/index";
import UserSetting from "../users/index";
const TabsContent = ({
  isUserManagementActive,
}) => {
	return (
		<>
			<TabPanel value="1">
				<SettingsPage />
			</TabPanel>
			<TabPanel value="2">
				<FinancialSettingPage />
			</TabPanel>

			<TabPanel value="3">
				<MembersSettingPage />
			</TabPanel>

			{isUserManagementActive ? (
				<div className="user__tab">
					<TabPanel value="5">
						<UserSetting />
					</TabPanel>
				</div>
			) : (
				<></>
			)}
			<div className="template__tab">
				<TabPanel value="6">
					<TemplatesSetting />
				</TabPanel>
			</div>


			<TabPanel value="4" >
				<EventSettingPage />
			</TabPanel>
		</>
	);
};

export default TabsContent;
